/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type VerificationCodeSendVariables = Types.Exact<{
  phone: Types.Scalars['String']
}>

export type VerificationCodeSend = {
  __typename: 'Root'
  verificationCodeSend: {
    __typename: 'VerificationCodeSendPayload'
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const VerificationCodeSendDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerificationCodeSend' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationCodeSend' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type VerificationCodeSendMutationFn = Apollo.MutationFunction<
  VerificationCodeSend,
  VerificationCodeSendVariables
>

/**
 * __useVerificationCodeSend__
 *
 * To run a mutation, you first call `useVerificationCodeSend` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerificationCodeSend` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verificationCodeSend, { data, loading, error }] = useVerificationCodeSend({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useVerificationCodeSend(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    VerificationCodeSend,
    VerificationCodeSendVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    VerificationCodeSend,
    VerificationCodeSendVariables
  >(VerificationCodeSendDocument, options)
}
export type VerificationCodeSendHookResult = ReturnType<
  typeof useVerificationCodeSend
>
export type VerificationCodeSendMutationResult =
  Apollo.MutationResult<VerificationCodeSend>
export type VerificationCodeSendMutationOptions = Apollo.BaseMutationOptions<
  VerificationCodeSend,
  VerificationCodeSendVariables
>
